/* eslint-disable @angular-eslint/no-input-rename */
/* eslint-disable @typescript-eslint/member-ordering */

import { Directive, HostListener, Input, OnInit, Renderer2 } from '@angular/core';
import { DomController } from '@ionic/angular';

@Directive({
    selector: '[appHideHeader]'
})
export class HideHeaderDirective implements OnInit {

    @Input('header') header: any;
    footer;
    private lastY = 0;
    timer;
    pause = false;
    constructor(
        private renderer: Renderer2,
        private domCtrl: DomController,
    ) { }

    ngOnInit(): void {
        this.header = this.header.el;
        this.footer = document.getElementById('main-tab-bar');
        this.domCtrl.write(() => {
            this.renderer.setStyle(this.header, 'transition', 'top 200ms');
            if (this.footer) { this.renderer.setStyle(this.footer, 'transition', 'bottom 200ms'); };
        });
    }

    @HostListener('ionScroll', ['$event']) onContentScroll($event: any) {
        // console.log('ionScroll', $event);
        if ($event.detail.scrollTop > this.lastY) {
            this.domCtrl.write(() => {
                if (this.pause === false) {
                    if ($event.detail.scrollTop > 200) {

                        this.renderer.setStyle(this.header, 'top', `-${this.header.clientHeight}px`);
                        if (this.footer) { this.renderer.setStyle(this.footer, 'bottom', `-80px`); };
                    }
                    if ($event.detail.scrollTop > 0) {
                        this.renderer.addClass(this.header, 'scrolled-sheild');
                    }
                } else {
                }
                this.renderer.addClass(this.header, 'scrolled-sheild');
            });
        } else {
            this.domCtrl.write(() => {
                this.pause = true;
                this.timer = setTimeout(() => {
                    this.pause = false;
                    clearTimeout(this.timer);
                }, 400);
                this.renderer.setStyle(this.header, 'top', '0');
                if (this.footer) { this.renderer.setStyle(this.footer, 'bottom', `5px`); };
                if ($event.detail.scrollTop < 20) {
                    this.renderer.removeClass(this.header, 'scrolled-sheild');
                }
                // if ($event.detail.scrollTop > 30) {
                //     this.renderer.addClass(this.header, 'scrolled-sheild');
                // }
            });
        }

        this.lastY = $event.detail.scrollTop;
    }

}
